import { useState, useEffect } from "react";

import Navbar from "./components/layout/Navbar";
import Footer from "./components/layout/Footer";
import LoaderA from "./components/common/LoaderA";

import HeroB from "./components/sections/HeroB";
import ExperienceA from "./components/sections/ExperienceA";
import Certificates from "./components/sections/Certificates";
import DemoOne from "./components/sections/Project";

export default function App() {
  const [isAppLoading, setIsAppLoading] = useState(true);

  useEffect(() => {
    if (isAppLoading) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isAppLoading]);

  return (
    <>
      {isAppLoading && <LoaderA onComplete={() => setIsAppLoading(false)} />}

      <div className="flex flex-col min-h-screen font-sans transition-colors duration-300 overflow-x-hidden">
        <Navbar />

        <HeroB />

        <div className="relative z-10 w-full bg-base-100">
          <ExperienceA />
        </div>

        <div className="relative z-10 w-full bg-base-100">
          <DemoOne />
        </div>

        <div className="relative z-10 w-full bg-gradient-to-b from-[#000000] to-">
          <Certificates />
        </div>

        <Footer />
      </div>
    </>
  );
}
